export default __webpack_public_path__ + "static/media/Right-Image.28de01ce.jpg";